<template>
  <v-card class="webpage-analyzer tools-view-card">
    <ToolbarHeader :name="'Webpage Analyzer'"/>
    <v-container>
      <section class="ma-5">
        <v-form
            v-model="formOptions.valid"
            v-on:submit.prevent="formSubmit()"
        >
          <v-row justify="center">
            <v-col cols="12"
                   sm="12"
                   md="6">
              <v-text-field
                  v-model="form.url"
                  required
                  :rules="formOptions.urlRules"
                  name="Url"
                  label="Url"
              />
            </v-col>
            <v-col cols="12"
                   sm="12"
                   md="2">
              <v-btn
                  :disabled="!formOptions.valid"
                  type="submit"
                  color="primary"
                  class="mt-3 w-100"
              >
                Analyze
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        <section v-if="WEBPAGE_ANALYZER_DATA">
          <section id="navigation">
            <nav class="navigation mb-5 mt-3 grid text-center">
              <a v-for="(item, index) in navigationList"
                 :key="index" href="#"
                 v-scroll-to="item.scrollTo"
                 @click="showExpansionPanel(index)">
                {{ item.name }}
              </a>
            </nav>
          </section>
          <v-btn v-if="expansionPanels.panel.length >= 1"
                 @click="hiddenAllExpansionPanels"
                 class="expansion-panels-hidden-button mb-5">
            <v-icon>mdi-chevron-up</v-icon>
          </v-btn>
          <v-btn v-else
                 @click="showAllExpansionPanels"
                 class="expansion-panels-hidden-button mb-5">
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
          <section id="analyzer-elements">
            <v-expansion-panels
                v-model="expansionPanels.panel"
                multiple
            >
              <v-expansion-panel id="meta">
                <v-expansion-panel-header class="title">Meta</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="expansion-panel-content">
                    <div>
                      <h3 class="title">
                        Title:
                        <v-btn icon small
                               @click="addToMapping({from:'webpage:title', to: 'title', datatype: 'string'})">
                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <p class="body-2">{{ WEBPAGE_ANALYZER_DATA.title }} </p>
                    </div>
                    <div>
                      <h3 class="title">
                        Meta Description:
                        <v-btn icon small
                               @click="addToMapping({from:'webpage:metaDescription', to: 'metaDescription', datatype: 'string'})">
                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <p class="body-2">{{ WEBPAGE_ANALYZER_DATA.metaDescription }} </p>
                    </div>
                    <div>
                      <h3 class="title">
                        Canonical:
                        <v-btn icon small
                               @@click="addToMapping({from:'canonical', to: 'canonical', datatype: 'string'})">
                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <p class="body-2">{{ WEBPAGE_ANALYZER_DATA.canonical }} </p>
                    </div>
                    <div>
                      <h3 class="title">
                        Base Url:
                        <v-btn icon small
                               @click="addToMapping({from:'webpage:baseUrl', to: 'baseUrl', datatype: 'string'})">
                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <p class="body-2">{{ WEBPAGE_ANALYZER_DATA.baseUrl }} </p>
                    </div>
                    <div>
                      <h3 class="title">
                        Domain:
                        <v-btn icon small
                               @click="addToMapping({from:'webpage:domain', to: 'domain', datatype: 'string'})">

                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <p class="body-2">{{ WEBPAGE_ANALYZER_DATA.domain }} </p>
                    </div>
                    <div v-if="WEBPAGE_ANALYZER_DATA.meta.name">
                      <h3 class="title">
                        Meta name:
                        <v-btn icon small
                               @click="addToMapping({from:'webpage:meta.name', to: 'meta.name', datatype: 'string'})">
                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <ul class="body-2">
                        <li v-for="(value, name) in WEBPAGE_ANALYZER_DATA.meta.name"
                            :key="name">
                          {{ name }}:
                          <v-btn icon small
                                 @click="addToMapping({from: `webpage:meta.name:['${name}']`, to: name, datatype: 'string'})">
                            <v-icon size="15">
                              mdi-content-copy
                            </v-icon>
                          </v-btn>
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                    <div v-if="WEBPAGE_ANALYZER_DATA.meta.property">
                      <h3 class="title">
                        Meta property:
                        <v-btn icon small
                               @click="addToMapping({from:'webpage:meta.property', to: 'meta.property', datatype: 'string'})">
                          <v-icon size="15">
                            mdi-content-copy
                          </v-icon>
                        </v-btn>
                      </h3>
                      <ul class="body-2">
                        <li v-for="(value, name) in WEBPAGE_ANALYZER_DATA.meta.property"
                            :key="name">
                          {{ name }}:
                          <v-btn icon small
                                 @click="addToMapping({from: `webpage:meta.property:['${name}']`, to: name, datatype: 'string'})">
                            <v-icon size="15">
                              mdi-content-copy
                            </v-icon>
                          </v-btn>
                          {{ value }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="heading">
                <v-expansion-panel-header class="title">Heading</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="expansion-panel-content" v-for="(value, name) in WEBPAGE_ANALYZER_HEADERS" :key="name">

                    <h3 class="title">
                      {{ name.toUpperCase() }}:
                      <v-btn icon small
                             @click="addToMapping({from: `webpage:${name}`, to: name, datatype: 'string'})">
                        <v-icon size="15">
                          mdi-content-copy
                        </v-icon>
                      </v-btn>
                    </h3>
                    <ul class="body-2">
                      <li v-for="(header, i) in WEBPAGE_ANALYZER_HEADERS[name]"
                          :key="i">
                        {{ header }}
                      </li>
                    </ul>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="json-ld" v-if="WEBPAGE_ANALYZER_DATA.jsonLd.length >= 1">
                <v-expansion-panel-header class="title">JSON LD</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="expansion-panel-content">
                                        <pre class="body-2">
                                            {{ JSON.stringify(WEBPAGE_ANALYZER_DATA.jsonLd, undefined, 4) }}
                                        </pre>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="images">
                <v-expansion-panel-header class="title">Images</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row class="expansion-panel-content">
                    <v-col lg="2" v-for="(image, i) in WEBPAGE_ANALYZER_DATA.images" :key="i">

                      <a target="_blank" :href="image">
                        <img
                            v-if="image"
                            :src="image"
                            class="expansion-panel-images-image"
                            alt="expansion-panel-images-image">
                      </a>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="request">
                <v-expansion-panel-header class="title">Request</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="expansion-panel-content">
                                        <pre class="body-2">
                                            {{ JSON.stringify(WEBPAGE_ANALYZER_DATA.request, undefined, 4) }}
                                        </pre>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="response">
                <v-expansion-panel-header class="title">Response</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="expansion-panel-content">
                                        <pre class="body-2">
                                            {{ JSON.stringify(WEBPAGE_ANALYZER_DATA.response, undefined, 4) }}
                                        </pre>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel id="mapping" v-if="WEBPAGE_ANALYZER_MAPPING.length >= 1">
                <v-expansion-panel-header class="title">
                  Mapping
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="expansion-panel-content">
                    <v-btn class="mapping-buttons mr-4"
                           icon small
                           @click="copy('mapping-text')">
                      <v-icon size="30">
                        mdi-content-copy
                      </v-icon>
                    </v-btn>
                    <v-btn @click="exportMappingToJsonFile"
                           class="mapping-buttons mr-4"
                           icon small>
                      <v-icon size="30">
                        mdi-download
                      </v-icon>
                    </v-btn>
                    <v-btn @click="resetMapping"
                           class="mapping-buttons mr-4"
                           icon small>
                      <v-icon size="30">
                        mdi-close-circle-outline
                      </v-icon>
                    </v-btn>
                    <pre class="body-2" id="mapping-text">
                                            {{ this.WEBPAGE_ANALYZER_MAPPING }}
                                        </pre>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </section>
        </section>
      </section>
    </v-container>
  </v-card>
</template>


<script>
import {mapGetters} from "vuex";
import ToolbarHeader from "@/components/Toolbar-Header";
import {copyMixin} from "@/mixins/copyMixin";

const form = {
  url: 'https://www.fritz-berger.de/artikel/getraenkekarton-halter-2628'
};

export default {
  name: "Webpage-Analyzer",
  mixins: [copyMixin],
  components: {ToolbarHeader},
  data: () => ({
    form: Object.assign({}, form),
    formOptions: {
      valid: false,
      urlRules: [
        v => !!v || 'Url is required',
      ]
    },
    expansionPanels: {
      panel: [],
      items: 7
    },
    navigationList: [
      {name: 'Meta', scrollTo: '#meta'},
      {name: 'Heading', scrollTo: '#heading'},
      {name: 'Json LD', scrollTo: '#json-ld'},
      {name: 'Images', scrollTo: '#images'},
      {name: 'Request', scrollTo: '#request'},
      {name: 'Response', scrollTo: '#response'},
    ],
  }),
  computed: {
    ...mapGetters([
      'WEBPAGE_ANALYZER_DATA',
      'WEBPAGE_ANALYZER_HEADERS',
      'WEBPAGE_ANALYZER_MAPPING'
    ]),
  },
  mounted() {
  },
  methods: {
    formSubmit() {
      this.$store.dispatch('GET_WEBPAGE_ANALYZER_DATA', {form: this.form})
          .then(() => {
            this.setHeadersValue();
            this.showAllExpansionPanels();
          })
    },
    setHeadersValue() {
      const headers = {h1: [], h2: [], h3: [], h4: [], h5: [], h6: []};
      for (const headersArrayKey in headers) {
        for (const webpageAnalyzerKey in this.WEBPAGE_ANALYZER_DATA) {
          if (headersArrayKey === webpageAnalyzerKey) {
            headers[headersArrayKey] = this.WEBPAGE_ANALYZER_DATA[webpageAnalyzerKey];
          }
        }
      }
      this.$store.dispatch('UPDATE_WEBPAGE_ANALYZER_HEADERS', headers);
    },
    hiddenAllExpansionPanels() {
      this.expansionPanels.panel = []
    },
    showAllExpansionPanels() {
      if (this.expansionPanels.panel <= this.expansionPanels.items) {
        for (let i = 0; i < this.expansionPanels.items; i++) {
          this.expansionPanels.panel.push(i);
        }
      }
    },
    showExpansionPanel(index) {
      if (this.expansionPanels.panel.indexOf(index) === -1) {
        this.expansionPanels.panel.push(index);
      }
    },
    addToMapping(value) {
      const object = {
        from: value.from,
        to: value.to,
        datatype: value.datatype
      };
      this.$store.dispatch('UPDATE_WEBPAGE_ANALYZER_MAPPING', object)
    },

    exportMappingToJsonFile() {
      let dataStr = JSON.stringify(this.mapping, undefined, 4);
      let dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
      let exportFileDefaultName = 'data.json';
      let linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    },
    resetMapping() {
      this.$store.dispatch('RESET_MAPPING');
    }
  }
}
</script>
<style type="text/css">

.webpage-analyzer .navigation a {
  padding: 10px;
  border-bottom: 1px solid var(--primary-color);
}

.webpage-analyzer .navigation a:hover {
  border-bottom: 1.5px solid var(--primary-color);
}

.expansion-panels-hidden-button {
  float: right;
}

.expansion-panel-images-image {
  max-width: 150px;
}

.mapping-buttons {
  float: right;
}
</style>
